import { useQuery } from '@apollo/client';
import { QUERY_INTERACTION_TARGET } from '../graphql';
export const useCachedInteractionTarget = (urn) => {
    var _a;
    const { data } = useQuery(QUERY_INTERACTION_TARGET, {
        fetchPolicy: 'cache-only',
        variables: { urn },
    });
    return (((_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.socialInteractionTarget) || {
        commentsCount: 0,
        id: '',
        reactionsCount: 0,
        sharesCount: 0,
        userReactionType: null,
    });
};
//# sourceMappingURL=use-cached-interaction-target.js.map